import { registerSW } from 'virtual:pwa-register';

console.log('PWA Service Worker loaded');

// Dynamically register service worker
const updateSW = () => {
    console.log('Update SW function called');
    registerSW({
        onNeedRefresh() {
            window.location.reload();
        },
        onOfflineReady() {
            console.log("App is ready to work offline!");
        },
        onRegistered(registration) {
            console.log('Service Worker registered:', registration);
        },
        onRegisterError(error) {
            console.error('Service Worker registration error:', error);
        }
    })
};

export default updateSW;
